import { useEffect } from "react";

export const STORE_NAME = "EA Italian Luxury Brands";

export function useSeo(title, description, jsonLd) {
  useEffect(() => {
    const base = STORE_NAME;
    document.title = title ? `${title} | ${base}` : `${base} — Italian luxury fashion for women, men & kids`;
    let m = document.querySelector('meta[name="description"]');
    if (m && description) m.setAttribute("content", description.slice(0, 160));
    let s = null;
    if (jsonLd) {
      s = document.createElement("script");
      s.type = "application/ld+json";
      s.text = JSON.stringify(jsonLd);
      s.setAttribute("data-seo", "1");
      document.head.appendChild(s);
    }
    return () => {
      if (s) s.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, jsonLd ? JSON.stringify(jsonLd) : ""]);
}
